import React from 'react'
import ImageStore from '../../stores/image-store'
import OpeLoader from '../utils/ope-loader'
import createReactClass from 'create-react-class'


var LargePreviewImage = createReactClass({
    mounted: false,

	getInitialState: function() {
		return {imageSrc: null};
	},

	loadImage: function () {
		var self = this;
		var imageItem = ImageStore.getImageById(this.props.imageId);
		var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

		imageItem.getSrcWithFilter(w > 1200 ? 1024 : 600, self.props.orderItem.getImageFilters()).then(function (src) {
			if (self.mounted) {
				self.setState({imageSrc: src});
			}
		})['catch'](function (err) {
			displayError(_("Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us."), {imageId: self.props.imageId, err: err});
		});
	},

	componentWillMount: function() {
		this.loadImage();
	},

	render: function() {
		var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 600);
		if (this.state.imageSrc === null) {
			return (
				<OpeLoader />
			);
		} else {
			return (
				<div style={{textAlign: 'center'}}>
					<img src={this.state.imageSrc} style={{maxHeight: (h-100) + 'px'}} alt="" />
				</div>
			);
		}
	},
    componentDidMount: function() {
        this.mounted = true;
    },
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default LargePreviewImage;
